import { ElementRef, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getHeight',
    standalone: false
})
export class GetHeightPipe implements PipeTransform {

  transform(id: string, elem: ElementRef, type, exp?: string): unknown {
    if (elem != undefined && elem) {
      switch (type) {
        //this works for checking the content of card and its height used in data grid
        case 'cardHeight': {
          let height = elem.nativeElement.scrollHeight;
          let clientHeight = elem.nativeElement.clientHeight;
          console.log("Height for card Data", height);
          console.log("Height for card Data", clientHeight);
          console.log("Height for card Data eval", eval(exp));
          return eval(exp);
        }
        //this is used in ui engine
        case 'tabWidth': {
          return new Promise(resolve => {
            setTimeout(() => {
              const isOverflowing = elem.nativeElement.scrollWidth > elem.nativeElement.offsetWidth;
              resolve(isOverflowing);
            }, 500); // this delay is because when we come from inside emr side menu we have added animation for left (default from coreui) which takes time
          });
          // return elem.nativeElement.scrollWidth > elem.nativeElement.offsetWidth;
        }
        default: {
          //do nothing
        }
      }
      //this works for da
    }
  }

}

